export default "/images/vendor/@coreui/icons/svg/flag/cif-lt.svg?29262e5a4bdde9bae21748eb49170233";